export default "__VITE_ASSET__Dj5SotR$__"